export default class CondicionalMercadoriaData {
  static unwrap(data, fallbackMessage = "Erro ao processar condicional.") {
    if (data?.status === false) {
      throw new Error(data?.msg || fallbackMessage);
    }

    return data?.data ?? data;
  }

  static async create(vm, payload) {
    const { data } = await vm.$http.post(
      "/condicional-mercadorias/create",
      payload
    );

    return this.unwrap(data, "Erro ao salvar condicional.");
  }

  static async update(vm, payload) {
    const { data } = await vm.$http.post(
      "/condicional-mercadorias/update",
      payload
    );

    return this.unwrap(data, "Erro ao atualizar condicional.");
  }

  static async find(vm, id_condicional_mercadoria) {
    const { data } = await vm.$http.post("/condicional-mercadorias/find", {
      id_condicional_mercadoria,
    });

    return this.unwrap(data, "Erro ao carregar condicional.");
  }

  static async relatorio(vm, payload = {}) {
    const { data } = await vm.$http.post(
      "/condicional-mercadorias/relatorio",
      payload
    );

    return this.unwrap(data, "Erro ao carregar relatório.");
  }

  static async estoqueDisponivel(vm, payload) {
    const { data } = await vm.$http.post(
      "/condicional-mercadorias/estoque-disponivel",
      payload
    );

    return this.unwrap(data, "Erro ao consultar estoque disponível.");
  }

  static async confirmarSaida(vm, id_condicional_mercadoria) {
    const { data } = await vm.$http.post(
      "/condicional-mercadorias/confirmar-saida",
      {
        id_condicional_mercadoria,
      }
    );

    return this.unwrap(data, "Erro ao confirmar saída.");
  }

  static async processarRetorno(vm, payload) {
    const { data } = await vm.$http.post(
      "/condicional-mercadorias/retorno",
      payload
    );

    return this.unwrap(data, "Erro ao processar retorno.");
  }

  static async prepararVenda(vm, id_condicional_mercadoria, options = {}) {
    const { data } = await vm.$http.post(
      "/condicional-mercadorias/preparar-venda",
      {
        id_condicional_mercadoria,
        ...options,
      }
    );

    return this.unwrap(data, "Erro ao preparar venda no PDV.");
  }

  static async historico(vm, id_condicional_mercadoria) {
    const { data } = await vm.$http.post("/condicional-mercadorias/historico", {
      id_condicional_mercadoria,
    });

    return this.unwrap(data, "Erro ao carregar histórico.");
  }

  static async imprimir(vm, id_condicional_mercadoria, formato) {
    const { data } = await vm.$http.post("/condicional-mercadorias/imprimir", {
      id_condicional_mercadoria,
      formato,
    });

    return this.unwrap(data, "Erro ao gerar impressão.");
  }

  static async cancelar(vm, id_condicional_mercadoria, motivo = null) {
    const { data } = await vm.$http.post("/condicional-mercadorias/cancelar", {
      id_condicional_mercadoria,
      motivo,
    });

    return this.unwrap(data, "Erro ao cancelar condicional.");
  }
}
